module.exports = __webpack_public_path__ + "static/media/S1_00015.caeed55b.jpg";